import React, { useState } from "react"
import ReactDOM from "react-dom"
import Button from "../components/CustomButtons/Button"
import { Box, Grid, Typography, TextField } from "@material-ui/core"
import { Link, navigate } from "gatsby"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme,
} from "@material-ui/core/styles"

import { Layout, ForgotPassBtn, LogoCenter, withRoot } from "../components"

const styles = theme => ({
  section: {
    marginTop: theme.spacing(3),
  },
})

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#f5f5f6",
    },
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  auth_form: {
    margin: "0 auto",
  },
  display5: {
    fontSize: "2rem",
    fontWeight: "500",
  },
  textField: {
    backgroundColor: "#ffffff",
    [`& fieldset`]: {
      borderRadius: 0,
    },
    "& .MuiOutlinedInput-root": {
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#27A6DE",
        },
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#27A6DE",
          borderWidth: "1px",
        },
      },
    },
  },
}))

const RecoverAccount = () => {
  const [formEl, setformEl] = useState({
    userEmail: "",
  })

  const inputHandler = event => {
    const { name, value } = event.target
    setformEl({ ...formEl, [name]: value })
  }
  const handleSubmit = event => {
    event.preventDefault()
    const userObj = {
      userEmail: formEl.userEmail,
    }
    // handleLogin(userObj, setuserLoggedInSuccessFully)
  }
  const classes = useStyles()
  return (
    <Layout noHeader={true}>
      <Box component="section" className="hbku-pg-wrapper hbku-auth-wrapper">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box component="div" className="auth-form-wrap pt-70">
              <Box
                component="div"
                className="auth-form w-xl-35 w-lg-55 w-sm-75 w-100"
              >
                <LogoCenter />
                <ValidatorForm
                  className={classes.form}
                  onSubmit={event => {
                    handleSubmit(event)
                  }}
                  onError={errors => console.log(errors)}
                >
                  <Typography
                    className={classes.display5 + " " + "mb-10 text-center "}
                    component="h4"
                    variant="h4"
                  >
                    Need help with your Password?
                  </Typography>
                  <Typography className="text-center mb-10" component="p">
                    We will send new code to your recovery email to{" "}
                    <Link to={"/recover-account"}>reset your </Link> password.{" "}
                  </Typography>
                  <Box component="div" className="form-group">
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextValidator
                          id="userEmail"
                          label="Email Address"
                          type="email"
                          name="userEmail"
                          autoComplete="email"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          autoFocus
                          value={formEl.userEmail}
                          onChange={inputHandler}
                          validators={["required", "isEmail"]}
                          errorMessages={["", "Email is not valid"]}
                        />
                        <ForgotPassBtn />
                        <Typography className="text-center" component="p">
                          <Link to={"/login"}> Back to login </Link>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </ValidatorForm>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  )
}
export default withRoot(withStyles(styles)(RecoverAccount))
